<div class="modal-header">
    <div class="title">
        <h2 class="modal-title-prefix"><span translate="TRANSPORTERI.SINGULAR"></span></h2>
    </div>
    <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
    <form [formGroup]="formGroup" class="">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input 
                            [Type]="'text'" 
                            [Label]="'FAKDOKUMENT.POZICIJA.SINGULAR'"
                            formControlName="Pozicija" 
                            [MaxLength]="100">
                        </yt-input>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input 
                        [Type]="'text'" 
                        [Label]="'FAKDOKUMENT.CMR.SINGULAR'"
                        formControlName="Crm" 
                        [MaxLength]="100">
                    </yt-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-multiselect
                        [ModelName]="'vozilo'"
                        [GetName]="'get'"
                        [ModelProperty]="'Naziv'"
                        [OrderBy]="'Naziv'"
                        formControlName="VozilaIds"
                        [AllowAddNew]="false" 
                        [Type]="'ID'"
                        [Label]="'FAKDOKUMENT.VOZILA.SINGULAR'"
                        (OnItemSelected)="DajStavkeVozila($event)"
                        (GetItems)="VozilaGetItems($event)"
                        >
                      </yt-multiselect>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group row">
                    <div class="col-md-6">
                        <yt-input 
                            [Type]="'text'" 
                            [Label]="'FAKDOKUMENT.VOZAC.SINGULAR'"
                            formControlName="Vozac" 
                            [MaxLength]="250">
                        </yt-input>

                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-text-area [MaxLength]="2000" name="txtNapomenaTransporteri" formControlName="NapomenaTransporteri"
                        [Label]="'FAKDOKUMENT.NAPOMENATRANSPORTERI.SINGULAR'"
                        [Height]="1">
                      </yt-text-area>

                    </div>
                </div>
            </div>
        </div>
        
    </form>
</div>
<div class="modal-footer">
    <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()" [disabled]="this.Parameters[6].Value"><span>Dopiši na tekući dokument</span></button>
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Odustani</span></button>
</div>